import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { IconButton as MuiIconButton, iconButtonClasses } from '@mui/material';
import { combineSx, toPixelString } from '../../utils';
import { iconButtonPadding } from './icon-button-overrides';
export const IconButton = /*#__PURE__*/ forwardRef(function IconButton({ isDisabled, size = 'medium', variant = 'tertiary', isDanger = false, children, sx, ...props }, ref) {
    return /*#__PURE__*/ _jsx(MuiIconButton, {
        ...props,
        ref: ref,
        color: "default",
        disabled: isDisabled,
        size: size,
        sx: combineSx((theme)=>{
            return isDanger ? dangerStylesByVariant[variant](theme) : stylesByVariant[variant](theme);
        }, sx),
        children: children
    });
});
const commonStyles = {
    [`&.${iconButtonClasses.sizeSmall}`]: {
        // Adjust the padding for each size to account for the 1px border
        padding: toPixelString(iconButtonPadding.small - 1),
        '.MuiSvgIcon-root': {
            width: '16px',
            height: '16px'
        }
    },
    [`&.${iconButtonClasses.sizeMedium}`]: {
        // Adjust the padding for each size to account for the 1px border
        padding: toPixelString(iconButtonPadding.medium - 1),
        '.MuiSvgIcon-root': {
            width: '20px',
            height: '20px'
        }
    }
};
const stylesByVariant = {
    // Tertiary are the default styles for MUI's IconButton and live
    // in icon-button-overrides.ts
    tertiary: ()=>({
            [`&.${iconButtonClasses.sizeSmall}`]: {
                '.MuiSvgIcon-root': {
                    width: '16px',
                    height: '16px'
                }
            },
            [`&.${iconButtonClasses.sizeMedium}`]: {
                '.MuiSvgIcon-root': {
                    width: '20px',
                    height: '20px'
                }
            }
        }),
    /**
   * Styles for the 'secondary' variant of IconButton.
   */ secondary: (theme)=>({
            ...commonStyles,
            backgroundColor: theme.palette.background.container,
            color: theme.palette.text.primary,
            border: `1px solid ${theme.palette.border.prominent}`,
            [`&:hover`]: {
                backgroundColor: theme.palette.background.hover,
                border: `1px solid ${theme.palette.text.secondary}`
            },
            [`&.${iconButtonClasses.disabled}`]: {
                color: theme.palette.text.disabled,
                border: `1px solid ${theme.palette.border.prominent}`
            }
        })
};
const dangerStylesByVariant = {
    tertiary: (theme)=>({
            ...commonStyles,
            color: theme.palette.status.error.main,
            [`&:hover`]: {
                backgroundColor: theme.palette.status.error.lowContrast
            },
            [`&.${iconButtonClasses.disabled}`]: {
                color: theme.palette.text.disabled
            }
        }),
    /**
   * Styles for the 'secondary' variant of IconButton.
   */ secondary: (theme)=>({
            ...commonStyles,
            color: theme.palette.status.error.main,
            border: `1px solid ${theme.palette.status.error.main}`,
            background: theme.palette.background.container,
            [`&:hover`]: {
                backgroundColor: theme.palette.status.error.lowContrast,
                border: `1px solid ${theme.palette.status.error.main}`
            },
            [`&.${iconButtonClasses.disabled}`]: {
                color: theme.palette.text.disabled,
                border: `1px solid ${theme.palette.border.prominent}`
            }
        })
};

//# sourceMappingURL=IconButton.js.map